import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host { display: block; }

    /* ══════════════════════════════════════════════════════════════════════
       Toolbar container
    ══════════════════════════════════════════════════════════════════════ */
    .uwc-toolbar {
      display:         flex;
      align-items:     center;
      gap:             var(--uwc-toolbar-gap, ${t.space2});
      padding:         var(--uwc-toolbar-padding, ${t.space2} ${t.space4});
      background:      var(--uwc-toolbar-bg, ${t.surface});
      border:          var(--uwc-toolbar-border, 1px solid ${t.border});
      border-radius:   var(--uwc-toolbar-radius, ${t.radiusLg});
      box-shadow:      var(--uwc-toolbar-shadow, none);
      min-height:      var(--uwc-toolbar-min-height, calc(${t.controlHeightMd} + ${t.space3}));
      box-sizing:      border-box;
    }

    /* ══════════════════════════════════════════════════════════════════════
       Sections
    ══════════════════════════════════════════════════════════════════════ */

    /* Start section — left-aligned, takes all remaining space */
    .uwc-toolbar__start {
      display:     flex;
      align-items: center;
      gap:         var(--uwc-toolbar-section-gap, ${t.space2});
      flex:        1 1 0%;
      min-width:   0;
    }

    /* Center section — shrinks to content, centred */
    .uwc-toolbar__center {
      display:     flex;
      align-items: center;
      gap:         var(--uwc-toolbar-section-gap, ${t.space2});
      flex:        0 1 auto;
    }

    /* End section — right-aligned, takes all remaining space */
    .uwc-toolbar__end {
      display:         flex;
      align-items:     center;
      justify-content: flex-end;
      gap:             var(--uwc-toolbar-section-gap, ${t.space2});
      flex:            1 1 0%;
      min-width:       0;
    }

    /* ══════════════════════════════════════════════════════════════════════
       Separator
    ══════════════════════════════════════════════════════════════════════ */
    .uwc-toolbar__separator {
      display:          block;
      width:            var(--uwc-toolbar-separator-width,  1px);
      height:           var(--uwc-toolbar-separator-height, 1.5rem);
      background:       var(--uwc-toolbar-separator-color,  ${t.border});
      border-radius:    var(--uwc-toolbar-separator-radius, ${t.radiusFull});
      flex-shrink:      0;
      /* Only visible when the adjacent slot has content */
      align-self:       center;
    }

    /* Hide separator when it has no preceding/following content.
       Achieved by having the host hide them via the :host-context trick
       — instead we always render them and let users control via CSS if needed. */

    /* ══════════════════════════════════════════════════════════════════════
       Slotted content helpers — items inside slots are flex children
    ══════════════════════════════════════════════════════════════════════ */
    ::slotted(*) {
      flex-shrink: 0;
    }

    /* Allow text/label spans to truncate gracefully */
    ::slotted(span),
    ::slotted(p) {
      white-space:   nowrap;
      overflow:      hidden;
      text-overflow: ellipsis;
      flex-shrink:   1;
    }
  `,
];
